import React from "react";
import Healing from "@mui/icons-material/Healing";
import {Redirect, useLocation} from "react-router-dom";
import { Link } from 'react-router-dom';

// material-ui
import { useTheme, styled } from '@mui/material/styles';
import { Button, Card, CardContent, CardMedia, Grid, Typography } from '@mui/material';

// project imports

import AnimateButton from '../../components/extended/AnimateButton';
import { gridSpacing } from '../../store/appConstant';

// assets
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';

import imageBackground from '../../assets/images/maintenance/img-error-bg.svg';
import imageDarkBackground from '../../assets/images/maintenance/img-error-bg-dark.svg';
import imageBlue from '../../assets/images/maintenance/img-error-blue.svg';
import imageText from '../../assets/images/maintenance/img-error-text.svg';
import imagePurple from '../../assets/images/maintenance/img-error-purple.svg';
import {useDispatch} from "react-redux";
import {activeItem} from "../../store/slices/menuSlice";
// styles
const CardMediaWrapper = styled('div')({
    maxWidth: 720,
    margin: '0 auto',
    position: 'relative'
});

const ErrorWrapper = styled('div')({
    maxWidth: 350,
    margin: '0 auto',
    textAlign: 'center'
});

const ErrorCard = styled(Card)({
    minHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

const CardMediaBlock = styled('img')({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    animation: '3s bounce ease-in-out infinite'
});

const CardMediaBlue = styled('img')({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    animation: '15s wings ease-in-out infinite'
});

const CardMediaPurple = styled('img')({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    animation: '12s wings ease-in-out infinite'
});

const NotFound = () => {
    const theme = useTheme();
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(activeItem(['accueil']));
        window.location.href = process.env.PUBLIC_URL;
    };
    const location = useLocation();
    const test =  location.pathname.split("/&customMessage=");
    if (test.length > 0 && test[0] === "/ui") {
        return <Redirect to={"/ui"} />
    }



    return (
        <ErrorCard>
            <CardContent>
                <Grid container justifyContent="center" spacing={gridSpacing}>
                    <Grid item xs={12}>
                        <CardMediaWrapper>
                            <CardMedia
                                component="img"
                                image={theme.palette.mode === 'dark' ? imageDarkBackground : imageBackground}
                                title="Slider5 image"
                            />
                            <CardMediaBlock src={imageText} title="Slider 1 image" />
                            <CardMediaBlue src={imageBlue} title="Slider 2 image" />
                            <CardMediaPurple src={imagePurple} title="Slider 3 image" />
                        </CardMediaWrapper>
                    </Grid>
                    <Grid item xs={12}>
                        <ErrorWrapper>
                            <Grid container spacing={gridSpacing}>
                                <Grid item xs={12}>
                                    <Typography variant="h1" component="div">
                                        Quelque chose ne va pas.
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        La page que vous recherchez a été déplacée, supprimée, renommée , peut ne jamais avoir existé
                                        ou votre accès n'est pas encore paramétré pour ce service ! {' '}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <AnimateButton>
                                        <Button variant="contained" size="large" onClick={handleClick} to={"/ui"}>
                                            <HomeTwoToneIcon sx={{ fontSize: '1.3rem', mr: 0.75 }} /> Accueil
                                        </Button>
                                    </AnimateButton>
                                </Grid>
                            </Grid>
                        </ErrorWrapper>
                    </Grid>
                </Grid>
            </CardContent>
        </ErrorCard>
    );
};


export default NotFound;
